import React, { FC } from 'react'

import { TasksTaskStatusEnum } from 'generated/resources/graphql'
import { debounce } from 'lodash'

import { useCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

export interface ProcessTasksFiltersType {
  search: string
  status?: TasksTaskStatusEnum
}

const DEFAULT_FILTERS: ProcessTasksFiltersType = {
  search: '',
}

const ProcessesTasksTableFiltersContext = React.createContext<{
  filters: ProcessTasksFiltersType
  search: string
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  onFiltersChanged: (filters: Partial<ProcessTasksFiltersType>) => void
  onFilterStatus: (status: TasksTaskStatusEnum) => void
} | null>(null)

export const ProcessesTasksTableFiltersProvider: FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [search, setSearch] = React.useState('')
  const [filters, setFilters] = React.useState<ProcessTasksFiltersType>(DEFAULT_FILTERS)

  const onFiltersChanged = (newFilters: Partial<ProcessTasksFiltersType>) =>
    setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }))

  const onChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(event.target.value)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateSearch = useCallback(
    debounce((search: string) => onFiltersChanged({ search }), 600),
    []
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useUnsafeEffect(() => updateSearch(search), [search])

  const onFilterStatus = (status: TasksTaskStatusEnum) => onFiltersChanged({ status })

  return (
    <ProcessesTasksTableFiltersContext.Provider
      value={{ filters, search, onChangeSearch, onFiltersChanged, onFilterStatus }}
    >
      {children}
    </ProcessesTasksTableFiltersContext.Provider>
  )
}
